/**
 * Decode common HTML entities back to their literal characters.
 *
 * Why: the backend's `sanitizeContent` (api/src/routes/messages.ts) used
 * to HTML-escape stored message content. React then renders that content
 * via `{msg.content}` which auto-escapes again, so a stored apostrophe
 * `&#039;` came out the other end as the literal text `&#039;` instead
 * of `'`. Same for quotes, ampersands, and angle brackets.
 *
 * The fix landed on 2026-05-17 in two places:
 *   1. Backend stopped escaping → new messages store the raw character
 *   2. This helper decodes for backward-compat with old messages still
 *      in D1 from before the fix
 *
 * Safe to use in JSX `{decodeHtmlEntities(value)}` — React will then
 * escape the result during render, so the round-trip is XSS-safe.
 */
export function decodeHtmlEntities(s: string | null | undefined): string {
  if (!s) return '';
  return s
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#0?39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&nbsp;/g, ' ');
}
